export default __webpack_public_path__ + "static/media/eyeNotSee.b215a31e.svg";